import { type MouseEvent } from 'react'
import { PharmacyZipFilter } from '@quickmd-llc/design-system'

type Props = {
  zipCode: string
  patientZipFallback: string
  onSave: (nextZip: string) => void
  onInteract: () => void
}

export function PharmacyZipFilterRow({ zipCode, patientZipFallback, onSave, onInteract }: Props) {
  const handleMouseDown = (event: MouseEvent<HTMLDivElement>) => {
    onInteract()
    const target = event.target as HTMLElement
    if (!target.closest('input')) {
      event.preventDefault()
    }
  }

  return (
    // The mousedown handler only keeps focus on the parent search input;
    // the interactive controls (input, buttons) live inside PharmacyZipFilter
    // and remain keyboard-accessible on their own.
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div className='tailwind-scoped' onMouseDown={handleMouseDown}>
      <PharmacyZipFilter className='m-sp-2' zipCode={zipCode} patientZipFallback={patientZipFallback} onSave={onSave} />
    </div>
  )
}
